import { ATIVO_TIPO } from '@investirapri/financa.js/lib/enums';
import { isAtivoRentabilidadeIndicadorAvailable } from '../../../../components/organisms/AtivoRentabilidade/ativoRentabilidadeIndicadores';
import { ATIVO_DISPLAY_MODE } from '../../../../components/organisms/ativoDisplayMode';

const wBenchmarkByAtivoTipo = {
  [ATIVO_TIPO.ACN.id]: 'IBOV',
  [ATIVO_TIPO.UNT.id]: 'IBOV',
  [ATIVO_TIPO.CTII.id]: 'IFIX',
  [ATIVO_TIPO.NTNB.id]: 'IMAB',
  [ATIVO_TIPO.NTNB1.id]: 'IMAB',
  [ATIVO_TIPO.LFT.id]: 'SELIC',
  [ATIVO_TIPO.LFTA.id]: 'SELIC',
  [ATIVO_TIPO.LFTB.id]: 'SELIC'
};

/** Retorna o indicador quando ele está disponível no gráfico de rentabilidade. */
function pvGetIndicadorAvailable(pIndicadorId) {
  return isAtivoRentabilidadeIndicadorAvailable(pIndicadorId) ? pIndicadorId : null;
}

/**
 * Define o benchmark inicial do ativo sem substituir referências cadastradas
 * que estejam indisponíveis no seletor atual.
 */
export function getAtivoDefaultBenchmark({
  ativo: pAtivo = {},
  ativoAvaliacao: pAtivoAvaliacao = {},
  displayMode: pDisplayMode
} = {}) {
  const xBenchmarkCadastrado =
    pAtivoAvaliacao?.avaliacao?.benchmark_indicador_id || pAtivo?.fundo?.benchmark_indicador_id;

  // O benchmark cadastrado tem precedência e não recebe fallback silencioso.
  if (xBenchmarkCadastrado) {
    return pvGetIndicadorAvailable(xBenchmarkCadastrado);
  }

  const xBenchmarkByAtivoTipo = wBenchmarkByAtivoTipo[pAtivo.ativo_tipo_id];

  if (xBenchmarkByAtivoTipo) {
    return pvGetIndicadorAvailable(xBenchmarkByAtivoTipo);
  }

  // Títulos bancários sem benchmark cadastrado usam a referência pós-fixada geral.
  if (pDisplayMode === ATIVO_DISPLAY_MODE.titulo_bancario) {
    return pvGetIndicadorAvailable('DI');
  }

  return null;
}
